export default __webpack_public_path__ + "static/media/chapter-step-2.259598e7.gif";